/// <reference types="@angular/localize" />

// Define global $localize polyfill for dynamic translation with ngx-translate
(window as any).$localize = function (parts: TemplateStringsArray | string[], ...expressions: any[]) {
  let raw = parts[0];
  if (Array.isArray(parts)) {
    for (let i = 1; i < parts.length; i++) {
      raw += (expressions[i - 1] !== undefined ? expressions[i - 1] : '') + parts[i];
    }
  } else {
    raw = String(parts);
  }

  let key = raw;
  if (raw.startsWith(':')) {
    const secondColonIndex = raw.indexOf(':', 1);
    if (secondColonIndex !== -1) {
      const metadata = raw.substring(1, secondColonIndex);
      const message = raw.substring(secondColonIndex + 1);

      const idMatch = metadata.match(/@@([^|]+)/);
      if (idMatch) {
        key = idMatch[1];
      } else {
        key = message;
      }
    }
  }

  const globalTranslate = (window as any).globalTranslate;
  if (globalTranslate && typeof globalTranslate.instant === 'function') {
    return globalTranslate.instant(key);
  }
  return key;
};

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
